/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit Content.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import BasicContributions from './BasicContributions/view.js'
import EffectiveDate from './EffectiveDate/view.js'
import EnhancedContributions from './EnhancedContributions/view.js'
import ExpiryDate from './ExpiryDate/view.js'
import Info from 'DesignSystem/Info/view.js'
import PlanBasic from './PlanBasic/view.js'
import PlanEnhanced from './PlanEnhanced/view.js'
import PlanOptions from './PlanOptions/view.js'
import React from 'react'
import SubTitle from 'DesignSystem/SubTitle/view.js'
import { css } from "emotion"

let styles = {}
styles.Vertical = css({label: 'Vertical',
  flexBasis: "auto",
flexGrow: 1,
flexShrink: 1,
marginTop: 60,
paddingRight: 40})
styles.Horizontal = css({label: 'Horizontal',
  flexDirection: "row",
marginTop: 20})
styles.Horizontal1 = css({label: 'Horizontal1',
  flexDirection: "row",
marginTop: 30,
marginBottom: 20,
marginLeft: 30})
styles.Horizontal2 = css({label: 'Horizontal2',
  flexDirection: "row",
marginTop: 30,
marginLeft: 30})

export default function Content({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  viewPath= "/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/EmployerContribution/Content"
}) {
    
    
    
    
    
    

  return (<React.Fragment
>
<div
 data-testid="Content.Vertical"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/EmployerContribution/Content"
 className={`views-block ${styles.Vertical}`}
>
<SubTitle
 data-testid="Content.SubTitle"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/EmployerContribution/Content"
viewPath={`${viewPath}/SubTitle`}
 text="Benefits term"
/>
<div
 data-testid="Content.Horizontal"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/EmployerContribution/Content"
 className={`views-block ${styles.Horizontal}`}
>
<EffectiveDate
 data-testid="Content.EffectiveDate"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/EmployerContribution/Content"
viewPath={`${viewPath}/EffectiveDate`}
/>
<ExpiryDate
 data-testid="Content.ExpiryDate"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/EmployerContribution/Content"
viewPath={`${viewPath}/ExpiryDate`}
/>
</div>
<SubTitle
 data-testid="Content.SubTitle:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/EmployerContribution/Content"
viewPath={`${viewPath}/SubTitle`}
 marginTop={50}
 text="Cost distribution - Basic Plan"
/>
<Info
 data-testid="Content.Info"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/EmployerContribution/Content"
viewPath={`${viewPath}/Info`}
 text="Enter your Employer contributions for each tier, if applicable."
 marginTop={8}
/>
<div
 data-testid="Content.Horizontal:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/EmployerContribution/Content"
 className={`views-block ${styles.Horizontal1}`}
>
<PlanOptions
 data-testid="Content.PlanOptions"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/EmployerContribution/Content"
viewPath={`${viewPath}/PlanOptions`}
/>
<PlanBasic
 data-testid="Content.PlanBasic"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/EmployerContribution/Content"
viewPath={`${viewPath}/PlanBasic`}
/>
<BasicContributions
 data-testid="Content.BasicContributions"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/EmployerContribution/Content"
viewPath={`${viewPath}/BasicContributions`}
/>
</div>
<SubTitle
 data-testid="Content.SubTitle:2"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/EmployerContribution/Content"
viewPath={`${viewPath}/SubTitle`}
 text="Cost distribution - Enhanced Plan"
 marginTop={8}
/>
<div
 data-testid="Content.Horizontal:2"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/EmployerContribution/Content"
 className={`views-block ${styles.Horizontal2}`}
>
<PlanOptions
 data-testid="Content.PlanOptions:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/EmployerContribution/Content"
viewPath={`${viewPath}/PlanOptions`}
/>
<PlanEnhanced
 data-testid="Content.PlanEnhanced"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/EmployerContribution/Content"
viewPath={`${viewPath}/PlanEnhanced`}
/>
<EnhancedContributions
 data-testid="Content.EnhancedContributions"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/EmployerContribution/Content"
viewPath={`${viewPath}/EnhancedContributions`}
/>
</div>
</div>
{children}
</React.Fragment>)
}